// Copyright (c) 2021 Deere & Company

import MassLaborRateRequestStatusContainer from '../../claim/mass-labor-rate-request-status-details/state-connector';

export default {
    component: MassLaborRateRequestStatusContainer,
    name: 'REQUEST_STATUS',
    path: 'request/details'
};



// WEBPACK FOOTER //
// ./src/routes/claims/mass-labor-rate-request-status.js